import { configureStore, combineReducers } from '@reduxjs/toolkit';
import user from './user';
import applicantPartners from './applicant.partners';
import activePartners from "./active.partners";
import partner from './partner';
import customer from './customer';
import customers from './customers';
import jobs from './jobs';
import jobsSearch from './jobs.search'
import locations from './locations';
import articles from './articles';
import mediaGuides from './mediaguides';

// Create the root reducer separately so we can extract the RootState type
const rootReducer = combineReducers({
  user: user,
  applicantPartners: applicantPartners,
  activePartners: activePartners,
  partner: partner,
  customer: customer,
  customers: customers,
  jobs: jobs,
  jobsSearch: jobsSearch,
  locations: locations,
  articles: articles,
  mediaGuides: mediaGuides,
});

export const setupStore = preloadedState => {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
  });
};